import React, { useContext } from "react";
import { LabelContext } from "../labels/LabelContext";
import { Accept, useDropzone, FileRejection, DropEvent } from "react-dropzone";
import { ResponsiveSize, ValidationState } from "../Types";
import styles from "./FilePicker.scss";
import classNames from "classnames";

export interface FilePickerProps {
  /**
   * Id of the element.
   */
  id?: string;
  /**
   * Element size, e.g. xs, sm, etc.
   */
   size?: ResponsiveSize;
  /**
   * Validation state.
   */
  state?: ValidationState;
  /**
   * Custom class
   */
  className?: string;
  /**
   * Control disabled
   */
  disabled?: boolean;
  /**
   * File types filter
   */
  accept?: Accept;
  /**
   * Multiple files
   */
  multiple?: boolean;
  /**
   * Custom text
   */
  text?: string;
  /**
   * On drop event
   */
/**
 * max file size
 */
  maxSize?: number;
  onChange?: (
    files: File[],
    fileRejections: FileRejection[],
    event: DropEvent
  ) => void;
}

/**
 * Input element with the corresponding aria tags.
 */
export const FilePicker: React.FC<FilePickerProps> = ({size = 'block', ...props}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: props.onChange && props.onChange,
    accept: props.accept,
    maxSize: props.maxSize,
    multiple: typeof(props.multiple) === "undefined" ? true : props.multiple
  });

  const labelCtx = useContext(LabelContext);

  const state = labelCtx.state || props.state;

  return (
    <>
      <div {...getRootProps({
        className: classNames(styles["au-filepicker"], {
          [styles[`au-filepicker--${state}`]]: state,
          [styles[`au-filepicker--disabled`]]: props.disabled,
          [styles[`au-filepicker--width-${size}`]]: size && size != 'block',
          [styles[`au-filepicker--block`]]: size == 'block'
        }, props.className)
      })}>
        <input {...getInputProps({
          id: props.id || labelCtx.id,
          disabled: props.disabled
        })} />
        <p>{props.text || "Drag 'n' drop some files here, or click to select files"}</p>
      </div>
    </>
  );
};
